// extracted by mini-css-extract-plugin
export default {"link":"style_link__rA67n","centerGrid":"style_centerGrid__ECiaK","img":"style_img__scpFT","namegame":"style_namegame__I5E+P","center":"style_center__8hsOs"};